import React, { useEffect, useState } from "react";
import { CircularProgress, makeStyles, Table, TableBody, TableContainer, TableHead, TableRow} from "@material-ui/core";
import axios from "axios";
import {MemberInfo, GroupInfo} from "../types/UserInfoTypes";
import config from '../config'

const useStyles = makeStyles({
  stickyHeader: {
    position: "sticky",
    left: 0,
    top:0,
    backgroundColor: "white",
  }
});

export function Groups( props: {
  member: MemberInfo,
}): JSX.Element {
  const [loading, setLoading] = useState(false)
  const [userGroups, setuserGroups] = useState<GroupInfo[]>([]);
  
  const classes = useStyles();

  useEffect(() => {
    fetchGroups(props.member);
  }, []);

  async function fetchGroups(member: MemberInfo) {
    try {
      setLoading(true);
      const userId = member.id;
      await axios.post(`${config.flowableUiApiBaseUrl}idm-app/rest/user/groups`, {userId}, { withCredentials: true }).then((response) => {
          const groups = response.data;
          if(groups.length > 0){
            setuserGroups(groups);
          } else {
            setuserGroups([]);
          }
          
      })

    } catch (e) {
      console.error(e);
    }
    finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <CircularProgress id={"changeRequestorLoader"}/>;
  }

  if (userGroups.length === 0) {
      return <div style={{marginTop: 5, marginBottom: 20}}>This user has no groups.</div>
  }

  return (
    <TableContainer style={{marginTop: 0, marginBottom: 30}}>
        <Table stickyHeader
        aria-label="simple table"
        style={{ tableLayout: "fixed" }}>
            <TableHead>
                <TableRow>
                    <th align="left" style={{ width: '220px', maxWidth: '220px', paddingLeft: '5px' }} className={classes.stickyHeader}>Name</th>
                </TableRow>
            </TableHead>
            <TableBody>
                {userGroups.map((group) => (
                    <TableRow key={group.id}>
                        <td style={{ paddingLeft: '10px' }}>{group.name}</td>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
  );
}
